// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.GridActionColumn.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

import React, { Component, PropTypes } from 'react';
import connect from 'share/enhancers/Izenda.Connect';
import constants from 'logic/data/Izenda.ReportDesignerConstants';
import classnames from 'classnames';
import { action } from 'mobx';
import { isNil, get } from 'lodash/fp';

@connect()
export default class GridActionColumn extends Component {
  static propTypes = {
    relationshipDetails: PropTypes.object.isRequired,
    store: PropTypes.object.isRequired
  };

  @action('onClickDelete')
  onClickDelete = () => {
    const { confirmFn, store, localization, relationshipDetails } = this.props;
    const { isKeyJoin, relationshipKeyJoins, parentId } = relationshipDetails;
    const { dataSourceDetail, reportStore } = store;

    const confirmDeleteMessage = !isNil(isKeyJoin)
      ? localization.getText('REPORTDESIGNER_MESSAGE_DELETE_KEYJOIN')
      : get('length', relationshipKeyJoins) > 0
      ? localization.getText('REPORTDESIGNER_MESSAGE_CONFIRM_DELETE_RELATIONSHIP_WITH_KEYJOIN')
      : localization.getText('REPORTDESIGNER_MESSAGE_CONFIRM_DELETE_RELATIONSHIP');

    confirmFn('Confirmation', { description: confirmDeleteMessage }).then(() => {
      !isNil(isKeyJoin)
        ? dataSourceDetail.findRelationshipById(parentId).deleteKeyJoin(relationshipDetails)
        : dataSourceDetail.delete(relationshipDetails);

      reportStore.model.markDirty();
      dataSourceDetail.markDataSourceGridDirty();
    });
  };

  @action('onClickCopy')
  onClickCopy = () => {
    const { store, relationshipDetails } = this.props;
    const { dataSourceDetail, reportStore } = store;
    const { isKeyJoin, parentId } = relationshipDetails;
    !isNil(isKeyJoin)
      ? dataSourceDetail.findRelationshipById(parentId).copyKeyJoin(relationshipDetails)
      : dataSourceDetail.copyRelationship(relationshipDetails);
    reportStore.model.markDirty();
    dataSourceDetail.markDataSourceGridDirty();
  };

  @action('onAddKeyJoin')
  onAddKeyJoin = () => {
    const { store, relationshipDetails } = this.props;
    const {
      reportStore,
      dataTree: { isAllDataOjectUncategory },
      dataSourceDetail
    } = store;

    relationshipDetails.addNewKeyJoin(isAllDataOjectUncategory);
    reportStore.model.markDirty();
    dataSourceDetail.markDataSourceGridDirty();
  };

  renderAddIcon() {
    const { localization, relationshipDetails } = this.props;
    const disableAddIcon = relationshipDetails.joinType === constants.JOIN_TYPES[3].label;

    const addIconClass = classnames('icon-plus', { 'disabled-elm': disableAddIcon });

    return (
      isNil(relationshipDetails.isKeyJoin) && (
        <a onClick={!disableAddIcon && this.onAddKeyJoin}>
          <span title={localization.getText('REPORTDESIGNER_LABEL_ADD_KEY_JOIN')} className={addIconClass} />
        </a>
      )
    );
  }

  renderCopyIcon() {
    const { relationshipDetails, localization } = this.props;
    const copyTooltip = relationshipDetails.isKeyJoin
      ? localization.getText('REPORTDESIGNER_TOOLTIP_COPY_KEY_JOIN')
      : localization.getText('REPORTDESIGNER_TOOLTIP_COPY_RELATIONSHIP');

    return (
      <a onClick={this.onClickCopy}>
        <span title={copyTooltip} className='icon-copy' />
      </a>
    );
  }

  renderDeleteIcon() {
    const { relationshipDetails, localization } = this.props;
    const deleteTooltip = relationshipDetails.isKeyJoin
      ? localization.getText('REPORTDESIGNER_TOOLTIP_DELETE_KEY_JOIN')
      : localization.getText('REPORTDESIGNER_TOOLTIP_DELETE_RELATIONSHIP');

    return (
      <a onClick={this.onClickDelete}>
        <span title={deleteTooltip} className='icon-cancel' />
      </a>
    );
  }

  render() {
    return (
      <div>
        {this.renderAddIcon()}
        {this.renderCopyIcon()}
        {this.renderDeleteIcon()}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/DataSource/Izenda.GridActionColumn.js